import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';

function Header() {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setActiveLink(location.pathname);
    setMenuOpen(false);
  }, [location.pathname]);

  const navItems = [
    { path: '/', label: 'About' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/blog', label: 'Blog' },
    { path: '/projects', label: 'Projects' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <header className="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-site z-[1000] bg-black/70 backdrop-blur-header border-b border-white/10 transition-all duration-300">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-gold focus:text-black focus:rounded-full focus:font-bold focus:text-sm">Skip to content</a>
      <div className="flex items-center justify-between px-6 py-3">
        <Link to="/" className="flex-shrink-0" aria-label="Alexandru Chiscari - Home">
          <img
            src={process.env.PUBLIC_URL + '/logo.svg'}
            alt="Alexandru Chiscari Logo"
            width="160"
            height="48"
            className={`transition-all duration-300 w-auto ${scrolled ? 'h-8' : 'h-12'}`}
          />
        </Link>

        <nav className="hidden md:block">
          <ul className="flex items-center gap-1 list-none m-0 p-0">
            {navItems.map(({ path, label }) => (
              <li key={path}>
                <Link
                  to={path}
                  onClick={() => setActiveLink(path)}
                  className={`px-4 py-2 rounded-full text-sm font-bold no-underline transition-all duration-200
                    ${activeLink === path
                      ? 'bg-gold text-black shadow-[0_0_12px_rgba(255,187,0,0.2)]'
                      : 'text-white/70 hover:text-white hover:bg-white/10'
                    }`}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <button
          className="md:hidden w-9 h-9 rounded-full bg-white/5 border border-white/10 text-white text-lg flex items-center justify-center transition-all duration-200 hover:bg-white/10"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
        </button>
      </div>

      {menuOpen && (
        <nav className="md:hidden animate-[fadeIn_0.2s]">
          <ul className="flex flex-col list-none m-0 p-0 px-6 pb-4 gap-1">
            {navItems.map(({ path, label }) => (
              <li key={path}>
                <Link
                  to={path}
                  onClick={() => setActiveLink(path)}
                  className={`block px-4 py-2 rounded-full text-sm font-bold no-underline transition-all duration-200
                    ${activeLink === path
                      ? 'bg-gold text-black shadow-[0_0_12px_rgba(255,187,0,0.2)]'
                      : 'text-white/70 hover:text-white hover:bg-white/10'
                    }`}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
}

export default Header;